<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <selection>
    <!-- <wang-editor style="height:0px;" ref="editor" :value="placeHolderValue"></wang-editor> -->

    <div id="pdfDom" ref="pdfDom" class="pdfDomClass">
      <div ref="innerDom" class="innerPdfDomClass">
        <p class="docTitle">首席科学家申请简表</p>

        <div class="pdf-line">
          <span class="pdf-title">申请航次名称：</span>
          <span class="pdf-content">{{ pdfItem.cruiseName }}（{{ pdfItem.cruiseNumber }}）</span>
        </div>

        <div class="pdf-line">
          <span class="pdf-title">调查区域（经纬度）：</span>
          <span class="pdf-content">{{ pdfItem.location }}</span>
        </div>

        <div class="pdf-line">
          <span class="pdf-title">调查时间：</span>
          <span class="pdf-content">{{ pdfItem.surveyTime }}</span>
        </div>

        <div class="pdf-line">
          <span class="pdf-title">首席科学家：</span>
          <span class="pdf-content">{{ pdfItem.chiefScientist }}</span>
        </div>

        <div class="pdf-line">
          <span class="pdf-title">单位：</span>
          <span class="pdf-content">{{ pdfItem.tenderUnit }}</span>
        </div>

        <div class="pdf-line" v-for="(item, index) in answers">
          <span class="pdf-title">{{ index + 1 }}、{{ item.questionContent }}</span>
          <div class="pdf-content" v-html="item.answer"></div>
        </div>

        <!-- <div class="pdf-line" style="line-height:50px">
        <span class="pdf-title">项目负责人签字：</span>
        <span style="display:block;margin-left:300px">
          <div class="bottomLine50" />年
          <div class="bottomLine25" />月
          <div class="bottomLine25" />日
        </span>
      </div>

      <div class="pdf-line" style="border-bottom:1px solid #000;line-height:50px">
        <span class="pdf-title">项目依托单位盖章：</span>
        <span style="display:block;margin-left:300px">
          <div class="bottomLine50" />年
          <div class="bottomLine25" />月
          <div class="bottomLine25" />日
        </span>
        </div>-->
      </div>
    </div>
  </selection>
</template>

<script>
import LinkComponent from '@/components/LinkComponent.vue';
import WangEditor from '@/components/Editor/WangEditor';
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';
import Vue from 'vue';
import { requestSvApply } from '@/api/SvpConfig';
import htmlToPdf from '../../utils/htmlToPdf';
import { formatDate } from '@/utils/date';

export default {
  components: { LinkComponent, WangEditor },
  name: 'ApplyPdf',
  props: {},
  computed: {},
  data() {
    return {
      placeHolderValue: '',
      selectPdfInfo: [],
      pdfItem: null,
      loading: true,
      answers: [],
      plusPage: this.$route.query.plusPage,
    };
  },
  activated() {
    axiosServer({
      url: urls.SvpCsApply + '/getOne/' + this.$route.query.applyId,
      params: this.reqBody, //将参数设置为变量
    })
      .then((resp) => {
        this.loading = false;
        if (resp.data.code == 0) {
          this.pdfItem = resp.data.page.list[0];
          setTimeout(() => {
            this.downloadPdf();
          }, 500);
        }
      })
      .catch((e) => {
        this.loading = false;
      });

    axiosServer({
      url: urls.SvpCsApplyAnswer + '/getOne',
      type: 'get',
      params: { page: 1, pageSize: 20, applyId: this.$route.query.applyId },
    })
      .then((resp) => {
        resp.data.page.list.forEach((item, index) => {
          if (item) {
            item.answer =
              '<div  class="w-e-text-container">' +
              '<div contenteditable="true" class="w-e-text" >' +
              item.answer +
              '</div></div>';
          }
        });
        this.answers = resp.data.page.list;
      })
      .catch((e) => {
        console.log(e);
      });
  },
  mounted() {},
  methods: {
    downloadPdf() {
      // this.$refs.innerDom.classList.add("snow-container");
      // return;
      setTimeout(() => {
        this.getPdf(
          this.$refs.pdfDom,
          this.$refs.innerDom,
          this.pdfItem.chiefScientist +
            '（' +
            this.pdfItem.tenderUnit +
            '）' +
            '-' +
            this.pdfItem.cruiseName +
            '（' +
            this.pdfItem.cruiseNumber +
            '）' +
            '首席科学家申请简表' +
            '-' +
            formatDate(new Date(), 'yyyyMMddhhmmss'),
          this.plusPage
        );
      }, 500);
    },
  },
};
</script>

<style>
.w-e-text table {
  border-top: 0px solid #ccc !important;
  border-left: 0px solid #ccc !important;
}

.w-e-text table td,
.w-e-text table th {
  border-bottom: 0px solid #ccc !important;
  border-right: 0px solid #ccc !important;
  /* padding: 3px 5px; */
}

.yemei {
  /* 页眉两边各20px距离 */
  width: 553px;
  border-bottom: #d6d5d5 solid 1px;
  font-size: 9px;
  line-height: 30px;
  padding-right: 30px;
  color: #9c9898;
  float: right;
  display: block;
  text-align: right;
  margin-right: 20px;
}

.bottomLine50 {
  display: inline-block;
  width: 50px;
  border-bottom: black solid 1px;
}
.bottomLine25 {
  display: inline-block;
  width: 25px;
  border-bottom: black solid 1px;
}

.docTitle {
  width: 593px;
  display: block;
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  padding-left: 50px;
  padding-right: 50px;
  color: #000;
}

.innerPdfDomClass {
  position: fixed;
  overflow: auto;
  padding: 0;
  column-gap: 0px;
  column-fill: auto;
  padding-top: 20px;
}

.pdfDomClass {
  background: #fffffe;
  position: fixed;
  width: 593px;
  left: 0px !important;
  top: 0px;
  overflow: auto;
}

.pdf-line {
  /* //这里要减去40，以为设置了margin-left 和 margin-right  */
  width: 553px;
  /* border: solid 1px #000; */
  border-bottom: none;
  line-height: 25px;
  margin-left: 20px;
  margin-right: 20px;
  padding-left: 10px;
  padding-right: 10px;
}

.pdf-title {
  min-width: 90px !important;
  color: #000;
  font-weight: bold;
  font-size: 12px;
  min-width: 150px;
}

.pdf-content {
  font-size: 12px;
  color: #000;
  font-weight: lighter;
}

.title-class2 {
  min-width: 130px;
}

.opButton {
  padding: 2px;
  width: 65px;
  margin-left: 5px;
  margin-top: 5px;
}
.proj-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
  padding: 0px;
  margin-bottom: 0px;
}
</style>
